/** The `mix-blend-mode` values the portrait's dots use: `normal` on the light theme, `screen`
    on the dark one. The index is the shaders' `uBlend` value. */
export const BLEND_MODES = ["normal", "screen"] as const;

export type BlendMode = (typeof BLEND_MODES)[number];

/** A mode's `uBlend` number. */
export function blendIndex(mode: BlendMode): number {
  return BLEND_MODES.indexOf(mode);
}

/** An opaque dot's color blended over a flat backdrop, the way `mix-blend-mode` would blend it
    with the page (W3C Compositing and Blending Level 1, in gamma-encoded sRGB, like browsers
    do). The canvases can't blend with the page in CSS, because the rotated portrait is its own
    blend group. The page behind the dots is one flat color, though, so the shader blends with
    that color, `uGround`. */
export const BLEND_GLSL = `
uniform int uBlend;
uniform vec3 uGround;

vec3 blend(vec3 b, vec3 s) {
  if (uBlend == 1) return b + s - b * s;
  return s;
}
`;
